/* ── HM Shared IntersectionObserver for scroll animations ── */
(function () {
  function initHmAnimations(root) {
    var scope = root || document;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('hm-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

    scope.querySelectorAll('.hm-animate').forEach(function (el) {
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initHmAnimations(); });
  } else {
    initHmAnimations();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initHmAnimations(e.target);
  });
})();
